export default "__VITE_ASSET__DFGqbs1d__"